import axios from 'axios';

class LeadValidationProvider {

  static async validateLead(idnumber,phonenumber) {

    //For Nou it fine hier, I will removed them and re create new cred when done testing
    const username = "vettingportal";
    const password = "SMYEikCvzVpYSn9acTyeXREZXSEjjG9aG9acTyacTyeXREZXSEjjYSn9acTyeXREZXSE";
    const authConfig = {auth: {username,password}};

    const data = {
      username: localStorage.getItem("userPrincipalName"),
      idnumber: idnumber,
      phonenumber: phonenumber
    }

    try{
      const res = await axios.post(process.env.REACT_APP_LEAD_VALIDATION,data,authConfig)
      if(res.data.status){
        return res.data.status;
      }else{
        return {"status":"error"};
      }
    }catch(error){
      console.log(error);
      return "error"; 
    }
  }
}

export default LeadValidationProvider;
